import type { PrintConfiguration } from 'types/templates';

export type PrintLinkConflict = 'fileName' | 'folderId' | 'returnFileContent' | 'fileFormat' | 'filter';

type LinkConflictInput = Pick<PrintConfiguration, 'fileFormat' | 'folderId' | 'fileName' | 'returnFileContent' | 'filter'>;

const isPositive = (value?: number | null) => value != null && value > 0;

export const isLinkingConfiguration = (configuration: Pick<PrintConfiguration, 'linkToRelationId'>) => isPositive(configuration.linkToRelationId);

export const getPrintLinkConflict = (values: Partial<LinkConflictInput>): PrintLinkConflict | null => {
  if (values.fileFormat && values.fileFormat !== 'Pdf') return 'fileFormat';
  if (values.returnFileContent === false) return 'returnFileContent';
  if ((values.fileName ?? '').trim() !== '') return 'fileName';
  if (isPositive(values.folderId)) return 'folderId';

  const filter = values.filter;
  if (
    filter &&
    (isPositive(filter.folderId) || isPositive(filter.filterId) || (filter.arguments ?? []).some((argument) => (argument?.name ?? '').trim() !== ''))
  ) {
    return 'filter';
  }

  return null;
};
